module.exports = __webpack_public_path__ + "static/img/zzc_4.ef67134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/Zuzuche_Pro/zzc_4.png
// module id = GjUT
// module chunks = 19